import React, { useEffect, useCallback } from 'react';
import { ZendeskAPI } from 'react-zendesk';
import {
  Route,
  Switch,
  Redirect,
  withRouter,
} from 'react-router-dom';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import PF2MScrollbar from '~/components/PF2MScrollbar';
import PF2MMenu from '~/components/PF2MMenu';
import Main from '../Main';
import ExpediteMaterials from './ExpediteMaterials';
import ExpediteDailyParts from './ExpediteDailyParts';
import styles from './styles';

const Expedite = ({ classes, match }) => {
  const validateNavigation = useCallback(() => true, []);

  const handleNavigation = (e, pathname = '') => {
    if (!validateNavigation(pathname)) {
      e.preventDefault();
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      ZendeskAPI('webWidget', 'hide');
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Main>
      <div className={classes.container}>
        <PF2MScrollbar style={{ width: 150, padding: 10 }}>
          <PF2MMenu
            handleNavigation={handleNavigation}
            moduleName="expedite"
          />
        </PF2MScrollbar>
        <div style={{ flex: 1 }}>
          <Switch>
            <Route exact path={`${match.path}/materials`} component={ExpediteMaterials} />
            <Route exact path={`${match.path}/dailyparts`} component={ExpediteDailyParts} />
            <Redirect from={`${match.path}`} to={`${match.path}/materials`} />
          </Switch>
        </div>
      </div>
    </Main>
  );
};

Expedite.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

Expedite.defaultProps = {};

export default withRouter(withStyles(styles)(Expedite));
